<div>
<mat-card *ngIf="client && !completedSaving" sm-restrict-width sm-center>
  <mat-card-title>{{ 'CARD_REQUEST.GREETING' | translate:{ firstName: client.firstName, lastName: client.lastName } }}</mat-card-title>
  <p sm-center>
    {{ 'CARD_REQUEST.CARD_REQUIRED' | translate }}
    <br />
    {{ 'CARD_REQUEST.CARD_STORED_SECURELY' | translate }}
  </p>
  <mat-card-content>
    <div
      class="card-element"
      [ngStyle]="{ display: stripeReady ? 'block' : 'none' }"
    >
      <div #paymentElement class="card-element-inner"></div>
    </div>
    <div class="stripe-charge-buttons">
      <p
        *ngIf="cardErrors"
        class="smc-stripe-error text-align-center"
      >
        {{ cardErrors }}
      </p>
    </div>

    <mat-checkbox [(ngModel)]="saveCardChecked"
      >{{ 'CARD_REQUEST.AUTHORIZE_STORING' | translate }}</mat-checkbox
    >
    <p
      sm-center
      class="gray-text margin-top-10 width-50 margin-left-right-auto"
    >
      {{ 'CARD_REQUEST.AUTHORIZE_TEXT' | translate:{ salonName: this.userService.getSalon().getName() } }}
    </p>

    <div sm-center class="margin-top-20">
      <button
        class="smc-button-large smc-button-primary margin-top-20"
        mat-raised-button
        [disabled]="!cardInputComplete || !saveCardChecked || savingStripe"
        (click)="onSave()"
      >
       {{ 'CARD_REQUEST.SAVE_IT' | translate }}
        <mat-progress-spinner
          *ngIf="savingStripe"
          [diameter]="20"
          mode="indeterminate"
        ></mat-progress-spinner>
      </button>
    </div>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="client && completedSaving" sm-restrict-width sm-center>
  <mat-card-title>{{ 'CARD_REQUEST.THANKS' | translate:{ firstName: client.firstName, lastName: client.lastName } }}</mat-card-title>
  <mat-card-content>
  </mat-card-content>
</mat-card>
</div>
